/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

window.sbBehaviours = window.sbBehaviours || {};
sbBehaviours.onlineRegistration = {
    properties: {
        tenantId: {
            type: String,
            value: sessionStorage.getItem("tenantId")
        }
    },
    submitDetails: function (url, method, body, headervalue, encryptedData) {
        var self = this;
        this.fire('start-processing-loader');
        let ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = url;
        ajaxCall.method = method;
        ajaxCall.body = body;

        if (ajaxCall.header == undefined || Object.keys(ajaxCall.header).length == 0) {
            // ajaxCall.headers["authorizationDetails"] = JSON.stringify({
            //     primaryAccessCode: headervalue.primaryAccessCode ? headervalue.primaryAccessCode : "",
            //     secondaryAccessCode: headervalue.secondaryAccessCode ? headervalue.secondaryAccessCode :
            //         "",
            //     userId: clientStorage.get(storageType.session, 'userId'),
            //     acceptTermsAndConditions: "",
            //     userRemarks: headervalue.userRemarks ? headervalue.userRemarks : ""
            // });
        }

        if (encryptedData !== undefined) {
            ajaxCall.headers["encrypteddata"] = sbEncrypt.encrypt(JSON.stringify(encryptedData));
        }

        ajaxCall.addEventListener('response', function (event) {
            self.loaderActive = false;
            self.fire('stop-processing-loader');
            if (event.detail.__data.status === 200 || event.detail.__data.status === 204) {
                self.successMessage = event.detail.__data.status;
                if (typeof self._callSucessPage == 'function') {
                    if (self.shadowRoot.activeElement)
                        self.shadowRoot.activeElement.blur();
                    self._callSucessPage(event);
                }
            }
        });
        ajaxCall.addEventListener('error', function (event) {
            self.loaderActive = false;
            self.fire('stop-processing-loader');
            if (event.detail.request.__data.status === 401) {
                if (event.detail.request.__data.response.error.message
                    .header != undefined) {
                    this.header = {
                        "primaryAccessCode": event.detail.request.__data.response.error.message
                            .header.authorization.firstAuthorizationMode,
                        "secondaryAccessCode": event.detail.request.__data.response.error
                            .message.header.authorization.secondAuthorizationMode
                    }
                    self.headerObject = this.header;
                    self.setAuthorizationModes(this.header);
                    self._callAuthPage(event);
                } else {
                    if (typeof self._errorHandler == 'function')
                        self._errorHandler(event);
                    self.fire('oe-show-error', event.detail.error.message);
                }
            } else {
                //Headers is obtained as a single string and JSON.stringify will stringify the whole string hence broken down
                var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
                var headers = convertedArr.reduce(function (each, current) {
                    var parts = [current.split(": ", 1).toString(), current.split(": ").slice(1).join(": ")];
                    each[parts[0]] = parts[1];
                    return each;
                }, {});
                if (headers.channelcontext) {
                    if (JSON.parse(headers.channelcontext).status.message[0]
                        .messageCode == "110314") {
                        self._callErrorPage();
                    } else {
                        self.fire('oe-show-error', JSON.parse(headers.channelcontext).status.message[0]
                            .messageDesc);
                    }

                } else {
                    self.fire('oe-show-error', event.detail.error.message);
                }

            }
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();

    },

    setAuthorizationModes: function (header) {

        this.authMethods = [];
        if (header.primaryAccessCode == "TPWD" && (!header.secondaryAccessCode ||
            header.secondaryAccessCode == '')) {
            this.authMethods = [{
                'method': 'TPWD',
                'wrapperValue': ''
            }];
        }
        // added by praveen.padigepati for resendOTP flow starts
        if (header.primaryAccessCode == "LGOTP") {
            this.authMethods = [{
                'method': 'LGOTP',
                'resendUrl': 'nonLoggedIn',
                'userDetails': this.userDetails,
                'wrapperValue': ''
            }];
        }
        // added by praveen.padigepati for resendOTP flow ends
        if (header.primaryAccessCode == "SOTP" && (!header.secondaryAccessCode ||
            header.secondaryAccessCode == '')) {
            this.authMethods = [{
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }];
        }
        if (header.primaryAccessCode == "TPWD" && header.secondaryAccessCode == "SOTP" || header.secondaryAccessCode == "OTP") {
            this.authMethods = [{
                'method': 'TPWD',
                'wrapperValue': ''
            }, {
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }];
        }
        if (header.primaryAccessCode == "SOTP" && header.secondaryAccessCode == "TPWD") {
            this.authMethods = [{
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }, {
                'method': 'TPWD',
                'wrapperValue': ''
            }];
        }

        if (this.authMethods.length == 0) {
            this.authMethods = [{
                'method': header.primaryAccessCode,
                'wrapperValue': ''
            }, {
                'method': header.secondaryAccessCode,
                'wrapperValue': ''
            }];
        }

    },
    authenticationValidation: function (autharray) {
        var authMethodLength = autharray.length;
        for (var i = 0; i < authMethodLength; i++) {
            if (autharray[i].method == "OTP" || autharray[i].method == "SOTP") {
                if (!autharray[i].wrapperValue) {
                    this.fire('oe-show-error', getLabel("m_OTPMandatory"));
                    return true;
                }
            } else if (autharray[i].method == "TPWD") {
                if (!autharray[i].wrapperValue) {
                    this.fire('oe-show-error', getLabel("m_TPWDMandatory"));
                    return true;
                }
            }
        }
    },
    clearAllFields: function () {
        localStorage.tenantId = sessionStorage.tenantId;
        var role = clientStorage.get(storageType.session, 'role');
        sessionStorage.clear();
        //Modified for checkmark issue: Injecting untrusted data
        this.redirectUrl=encodeURI(location.href);
        if (window.location.protocol == 'file:') {
            if (getNavigationItem("userAgent").match(/Windows|Android|webOS|iPhone|iPod|Blackberry|iPad/i) || role === "consumer" || role === "corporate") {
                this.redirectUrl = localStorage.uibaseroute + "/index.html";
                localStorage.tenantId = "";
            } else if (getNavigationItem("userAgent").match(/Windows|Android|webOS|iPhone|iPod|Blackberry|iPad/i) && role === "admin") {
                this.redirectUrl = localStorage.uibaseroute + "/indexAdmin.html";
            }
        } else {
            if (getNavigationItem("userAgent").match(/Windows|Android|webOS|iPhone|iPod|Blackberry|iPad/i) || role === "consumer" || role === "corporate") {
                this.redirectUrl = localStorage.uibaseroute + "?bank_id=" + localStorage.getItem("tenantId");
                // clear tenant id from localstorage
                localStorage.tenantId = "";
            }
        }
        location.href = this.redirectUrl;

    }

}
